/**
* @Description 文件功能说明：组织结构组件
* @Author
* @Time 
**/

/* HTML */
<template>
    <div class="rightBody">
        <section style="height: 100%;width: 100%;">
            <!-- 父组件 盒子 start -->
            <div class="parent-item-box">
                <!-- 项目明细 -->
                <ProjectDetail :nodeData="nodeData" @setSelectVal="setSelectVal" @addNode="addNode" v-if="nodeLevel==1"/>
                <!-- 区域明细 -->
                <AreaDetail :nodeData="nodeData" @setSelectVal="setSelectVal" @addNode="addNode" v-if="nodeLevel==2"/>
                <!-- 地图明细 -->
                <MapDetail :nodeData="nodeData" @setSelectVal="setSelectVal" v-if="nodeLevel==3"/>
            </div>
            <!-- 父组件 盒子 end -->

            <!-- 子组件 盒子 start -->
            <div class="child-item-box" v-if="this.addFlag">
                <!-- 添加区域 -->
                <AreaAdd :nodeData="nodeData" @setSelectVal="setSelectVal" @addNode="addNode" v-if="nodeLevel>0 && this.nodeData.node.hasArea==1"/>
                <!-- 添加地图 -->
                <MapAdd :nodeData="nodeData" @setSelectVal="setSelectVal" @addNode="addNode" v-if="nodeLevel>0 && this.nodeData.node.hasArea!=1"/>
            </div>
            <!-- 子组件 盒子 end -->
        </section>
    </div>

</template>

/* JS */
<script>
// 表单组件
// 项目明细
import ProjectDetail from './ProjectDetail'
// 区域明细
import AreaDetail from './AreaDetail'
// 添加区域
import AreaAdd from './AreaAdd'
// 地图明细
import MapDetail from './MapDetail'
// 添加地图
import MapAdd from './MapAdd'

export default {
    /**
     * @Des 组件名
     * @Auth
     * @Date 
     */
    name: 'OrgModule',

    /**
     * @Des 组件注册
     * @Auth
     * @Date 
     */
    components: {
        ProjectDetail,
        AreaDetail,
        MapDetail,
        AreaAdd,
        MapAdd,
    },

    /**
     * @Des 数据接收类型
     * @Auth
     * @Date 
     */
    props: {
        // 节点信息
        nodeData: Object,
        nodeLevel: Number,
    },
    /**
     * @Des 数据定义
     * @Auth
     * @Date 
     */
    data() {
        return{
            addFlag: false,
        }
    },
    /**
     * @Des 方法定义
     * @Auth
     * @Date 
     */
    methods:{
        /**
         * 修改数据
         * @param data
         * @param flushOrg
         */
        setSelectVal(data, flushOrg){
            this.$emit("setSelectVal", data, flushOrg);
        },
        /**
         * 新增模块
         * @param status
         */
        addNode(status){
            this.addFlag = status;
        },
    }
}
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Organization/OrgModule.vue